// Russian copy for the /landing page.
// Key order mirrors src/copy/landing.en.js, which is page order top to bottom.
// A key deleted here silently falls back to the English string.

export default {
  // ============ HERO  (very top of the page) ============
  "landing.heroTitle": "От первых слов до настоящих разговоров.",
  "landing.heroSubtitle": "Приложение для речевой практики для детей, которым трудно говорить. Рядом Тимо.",
  "landing.ctaGetStarted": "Начать",
  "landing.heroStat1Big": "400+",
  "landing.heroStat1Label": "родителей уже попробовали",
  "landing.heroStat2Big": "3 режима",
  "landing.heroStat2Label": "для каждого ребёнка",
  "landing.heroStat3Label": "сделано в Литве",

  // ============ RADIO STRIP  (the thin line under the hero) ============
  "landing.radioMention": "О нас говорили на национальном радио.",
  "landing.radioLinkText": "Žinių radijas",

  // ============ THE THREE CARDS ============
  "landing.promiseTitle": "Экранное время, которое что-то даёт.",
  "landing.promiseBody": "Вместо бесконечной ленты ребёнок играет с Тимо и учит фразы, которые нужны в жизни. Всего 10 минут в день.",
  "landing.card1Title": "Нажми и говори",
  "landing.modeNonverbalDesc": "Ребёнок нажимает на картинку, и Тимо произносит это вслух. Читать не нужно. Идеально для неговорящих детей и детей с задержкой речи.",
  "landing.card3Title": "Забота о Тимо",
  "landing.modeLiveDesc": "Игра, а не урок. Дети кормят Тимо, укладывают его спать и заботятся о нём. Чтобы помочь, им нужно сказать, что ему нужно, и это практика, похожая на игру.",
  "landing.card2Title": "Разговор с Тимо",
  "landing.modeChatDesc": "Тренируйте настоящие разговоры с Тимо: попросить помощи, присоединиться к игре. Тимо помогает по ходу.",

  // ============ HOW IT WORKS  (three numbered steps) ============
  "landing.howItWorks": "Как это работает",
  "landing.howStep1Title": "Нажми на картинку",
  "landing.howStep1Body": "Ребёнок выбирает то, что хочет сказать, и Тимо произносит это вслух.",
  "landing.howStep2Title": "Тренируйся с Тимо",
  "landing.howStep2Body": "Те же фразы возвращаются как разговор с Тимо, поэтому произносить их становится привычно ещё до настоящей жизни.",
  "landing.howStep3Title": "Играй и расти",
  "landing.howStep3Body": "Забота о Тимо превращает практику в игру, к которой хочется возвращаться, и просить о чём-то становится естественно.",

  // ============ ORANGE BAND  (full-width, between the steps and the tiles) ============
  "landing.problemTitle": "Вы знаете, что им есть что сказать.",
  "landing.problemBody": "Слова внутри. Просто что-то мешает в самый важный момент: новый человек, шумная комната, вопрос, на котором они замирают.",

  // ============ WHAT ELSE IS INSIDE  (three tiles) ============
  "landing.whatWeBuilt": "Что ещё внутри:",
  "landing.featWordTitle": "Слово дня",
  "landing.featWordDesc": "Одно новое слово в день, оно ждёт в домике Тимо. Ребёнок слышит его, повторяет и оставляет в своём списке слов.",
  "landing.featScriptsTitle": "Фразы, которые можно сохранить",
  "landing.featScriptsDesc": "Сохраняйте предложения, которые работают: для магазина, для класса, для врача. Потренируйте одно перед входом, и в следующий раз оно уже будет под рукой.",
  "landing.featBreathingTitle": "Дыхание для успокоения",
  "landing.featBreathingDesc": "Дыхательное упражнение с подсказками для моментов, когда всё становится слишком громким, чтобы ребёнок мог перевести дух и вернуться. (BETA)",

  // ============ PARENTS LOVE IT  (the two quotes) ============
  "landing.parentsLoveIt": "Родителям нравится.",
  "landing.testimonialAlt1Quote": "По-настоящему отличная идея - это приложение стоит показать специалистам в школах и детских садах.",
  "landing.testimonialAlt1Name": "Катрина С.",
  "landing.testimonialAlt1Author": "Мама, Литва",
  "landing.testimonialAlt2Quote": "Замечательная идея. Работая с людьми, которые не могут говорить, вижу, что это приложение действительно помогло бы.",
  "landing.testimonialAlt2Name": "Вида К.",
  "landing.testimonialAlt2Author": "Специалист, работающий с неговорящими взрослыми",

  // ============ ARTICLES RAIL  (the small label above each cover) ============
  "landing.artCat1": "Первые слова",
  "landing.artCat2": "Неговорящие",
  "landing.artCat3": "Аутизм",
  "landing.artCat4": "Тревожность",
  "landing.artCat5": "Как выбрать",

  // ============ FOUNDER BLOCK ============
  "landing.ourStory": "Как мы это построили",
  "landing.founderName": "Гинтарас",
  "landing.founderQuote": "У моего брата синдром Аспергера. Первую версию я сделал для него, чтобы моменты, которые другим даются легко, перестали быть самой трудной частью его дня.",
  "landing.founderStory": "Потом я встретил отца, чей сын совсем не говорил, и мы сделали режим нажми и говори: ребёнок нажимает, а приложение произносит вслух. После этого я всё чаще встречал детей с поздней речью, которые только осваивали первые слова, и превратил всё это в игру. Практика должна ощущаться как игра, а не как домашнее задание.",
  "landing.founderRole": "Основатель Timo Helps",

  // ============ LONG READ  (the collapsed block above the FAQ) ============
  "landing.longTitle": "Приложение для речевой практики, которое помещается в обычный день",
  "landing.longP1": "Timo Helps (он же Time To Talk) - это приложение для общения и речевой практики для детей, которым трудно говорить: детей с задержкой речи, неговорящих и малоговорящих детей, детей с аутизмом, детей с СДВГ и тех, кто свободно говорит дома, но замирает в школе, у врача или в магазине. Оно работает в браузере на телефоне, планшете или ноутбуке, поэтому ничего не нужно устанавливать и нечего ждать.",
  "landing.longP2": "Оно работает тремя способами. Нажми и говори - это доска с картинками: ребёнок нажимает на то, что хочет сказать, и приложение произносит это вслух, так что голос у него есть с первого дня, без чтения и без набора текста. Разговор с Тимо - это тренировочный диалог с мягким персонажем, который никогда не торопит и не поправляет при других, поэтому фразы для заказа еды, просьбы о помощи или присоединения к игре сначала репетируются в безопасном месте. Забота о Тимо превращает всё это в игру: дети кормят его, укладывают спать и заботятся о нём, а чтобы это сделать, им нужно сказать, что ему нужно.",
  "landing.longP3": "Вокруг этих трёх режимов есть слово дня, место для фраз, которые действительно работают в вашей семье, дыхательное упражнение для моментов, когда становится слишком громко, и награды, отмечающие прогресс так, чтобы практика не превращалась в домашнее задание. Приложение доступно на литовском, английском, русском и испанском.",
  "landing.longP4": "Timo Helps не заменяет логопеда. Это практика между занятиями: открыть в 7 утра или перед сном, вместе с планом специалиста. Оно создано в Литве основателем, чей брат сам замолкал рядом с новыми людьми, и сегодня им пользуются более 400 семей. 11,49 EUR в месяц, отменить можно в любой момент, без рекламы, и ничего о вашем ребёнке никому не продаётся.",
  "landing.readMore": "Читать дальше",
  "landing.readLess": "Свернуть",

  // ============ FAQ  (eleven rows) ============
  "landing.faqSectionTitle": "Часто спрашивают",
  "landing.faq1Question": "Для кого Тимо?",
  "landing.faq1Answer": "Для детей примерно от 3 лет: детей с задержкой речи, неговорящих и малоговорящих детей, детей с аутизмом и любого ребёнка, которому трудно говорить или который замирает в важный момент. Многие родители используют его и просто чтобы ребёнок потренировался складывать повседневные фразы.",
  "landing.faq2Question": "Нужно ли ребёнку уметь читать?",
  "landing.faq2Answer": "Нет. Time To Talk (Timo Helps) работает на картинках и значках. Читать не требуется.",
  "landing.faq3Question": "А если нам не подойдёт?",
  "landing.faq3Answer": "Отменить можно в любой момент: Профиль, затем Подписка. Доступ сохраняется до конца оплаченного месяца.",
  "landing.faq4Question": "Наши данные в безопасности?",
  "landing.faq4Answer": "Да. Мы никогда не продаём ваши данные. Никогда. Приватность прежде всего.",
  "landing.faq5Question": "Сколько это стоит?",
  "landing.faq5Answer": "11,49 EUR в месяц за всё и на всех устройствах. Без привязки, отменить можно в любой момент.",
  "landing.faq6Question": "На каких устройствах работает?",
  "landing.faq6Answer": "Оно работает в браузере, поэтому подойдёт телефон, планшет или ноутбук, и устанавливать ничего не нужно. На телефоне его можно добавить на главный экран, и оно будет открываться как обычное приложение.",
  "landing.faq7Question": "На каких языках говорит?",
  "landing.faq7Answer": "Литовский, английский, русский и испанский, а в BETA французский, немецкий и норвежский. Язык выбирается на входе и меняется позже в настройках.",
  "landing.faq8Question": "Заменяет ли это логопеда?",
  "landing.faq8Answer": "Нет, и не должно. Специалист работает над тем, как ребёнок произносит речь. Тимо даёт место для практики между занятиями, столько раз, сколько захочется.",
  "landing.faq9Question": "Сколько времени это занимает?",
  "landing.faq9Answer": "Достаточно нескольких минут. Никаких серий, никаких дневных норм, ничего, что наказывало бы за пропущенный день. Большинство семей занимаются короткими подходами: перед магазином, после школы, перед сном.",
  "landing.faq10Question": "Нужно ли сидеть рядом с ребёнком?",
  "landing.faq10Answer": "Можно, и вначале это помогает. Но приложение сделано так, чтобы ребёнок мог открыть его сам: всё в картинках, всё нажимается, а читает Тимо.",
  "landing.faq11Question": "Как начать?",
  "landing.faq11Answer": "Вы отвечаете на несколько вопросов о ребёнке, и приложение настраивается под его уровень и названные вами ситуации. Это занимает пару минут, и всё можно поменять позже.",

  // ============ FINAL CTA AND EVENT CODE  (bottom of the page) ============
  "landing.priceTeaserTitle": "11,49 EUR в месяц",
  "landing.priceTeaserBody": "Меньше чашки кофе в неделю. Все режимы и все языки включены, отменить можно в любой момент.",
  "landing.ctaPlans": "Смотреть тарифы",
  "landing.eventCodeTitle": "Есть код автора или мероприятия?",
  "landing.eventCodePlaceholder": "Введите код",
  "landing.eventCodeCta": "Применить код",
  "landing.eventCodeNote": "Одно использование на человека. За злоупотребление или передачу кода следует блокировка.",

  // ============ TOP BAR, MENU AND FOOTER ============
  "landing.signIn": "Войти",
  "landing.ctaTryTimo": "Попробовать Тимо",

  "landing.tryFree": "Получить Timo",
  "landing.cancelAnytime": "Отменить в любое время.",
  "landing.feature1Title": "Нажмите, чтобы говорить",
  "landing.feature1Desc": "Картинки, на которые нажимает ваш ребенок. Тимо произносит вслух.",
  "landing.feature2Title": "Практические разговоры",
  "landing.feature2Desc": "Общайтесь с Тимо. Без осуждения. Попробуйте еще раз.",
  "landing.feature3Title": "Живая помощь",
  "landing.feature3Desc": "Предложения в реальном времени во время разговоров.",
  "landing.quote": "Мой сын нажал на картинку, и приложение сказало то, что он хотел. Он посмотрел на меня так, будто ты это слышала. Мы оба плакали.",
  "landing.quoteAuthor": "Мама 7-летнего ребенка с аутизмом, Литва",
  "landing.stayUpdated": "Будьте в курсе",
  "landing.stayUpdatedDesc": "Получайте советы и истории от семей, подобных вашей.",
  "landing.subscribe": "Подписаться",
  "landing.subscribing": "Отправка...",
  "landing.subscribeSuccess": "✓ Спасибо! Проверьте свою электронную почту в ближайшее время.",
  "landing.navPricing": "Тарифы",
  "landing.heroCtaPricing": "Выбрать план",
  "landing.storyIntro": "Мы кое-что заметили",
  "landing.storyPoint1": "Люди общаются по-разному.",
  "landing.storyPoint2": "Некоторые используют слова. Некоторые используют значки. Некоторые делают и то, и другое.",
  "landing.storyPoint3": "Большинство приложений выбирают один способ и придерживаются его.",
  "landing.storyWeBuild": "Мы создали три режима в одном приложении.",
  "landing.modeNonverbal": "Говори",
  "landing.modeChat": "Чат",
  "landing.modeLive": "В прямом эфире",
  "landing.storyStats": "187 семей используют его",
  "landing.storyUsage": "86% используют его ежедневно",
  "landing.storyBuiltIn": "Создано в Литве",
  "landing.storyExpanding": "В течение 2026 года мы планируем расширяться по всей ЕС",
  "landing.storyTryButton": "Получить Timo →",
  "landing.heroCtaTry": "Получить Timo",
  "landing.heroCtaGet": "Получить Time To Talk",
  "landing.stats1Number": "130+",
  "landing.stats1Label": "семей зарегистрировано",
  "landing.stats2Number": "3 режима",
  "landing.stats2Label": "для каждого ребенка",
  "landing.stats3Number": "🇱🇹",
  "landing.stats3Label": "сделано в Литве",
  "landing.modesTitle": "Одно приложение. Три способа помочь.",
  "landing.modesSubtitle": "Некоторые дети не могут говорить. Некоторые боятся. Некоторым просто нужна помощь в данный момент.",
  "landing.modeNonverbalTitle": "Режим «Говори»",
  "landing.modeChatTitle": "Режим чата",
  "landing.modeLiveTitle": "Позаботься о Тимо",
  "landing.modeLiveBadge": "НОВОЕ",
  "landing.scrollHint": "листать",
  "landing.featAwardsTitle": "Награды и прогресс",
  "landing.featAwardsDesc": "Трофеи отмечают каждый шаг, поэтому практика общения ощущается как игра, а не домашнее задание.",
  "landing.devBypassLogin": "Обход входа для разработчика",
  "landing.devBypassHome": "Обход в приложение (тест)",
  "landing.testimonialQuote": "Он использовал его в первый день. Он попросил воды сам. Впервые.",
  "landing.testimonialAuthor": "Родитель из Вильнюса",
  "landing.founderTitle": "Привет, я Гинтарас",
  "landing.founderHook": "Я наблюдал, как мой брат замолкал каждый раз, когда кто-то новый с ним разговаривал. Учителя. Другие дети. Люди снаружи.",
  "landing.founderProblemLabel": "Проблема",
  "landing.founderProblemText": "Дома он мог говорить нормально. Где-то еще? Пропал. Поэтому я решил создать инструмент, который помогает людям говорить.",
  "landing.founderSearchLabel": "Что я нашел",
  "landing.founderSearchText": "Я искал приложения для помощи. Все, что я нашел, было сложным и бесполезным.",
  "landing.founderBuildLabel": "Что я построил в 16 лет",
  "landing.founderBuildPoint1": "Затем я встретил родителя, чей ребенок буквально не мог сказать «Я голоден» или поддерживать общение с близкими.",
  "landing.founderBuildPoint2": "Две разные проблемы. Ноль хороших решений. Я начал создавать Time To Talk в 16 лет.",
  "landing.founderBuildPoint3": "Нажмите на значок, и приложение заговорит. Практикуйте разговоры без давления. Получите помощь в разговоре в реальном времени, когда вы замрете.",
  "landing.founderForWho": "Для всех, кому нужна помощь в разговорах.",
  "landing.founderLine1": "Я наблюдал, как мой брат замолкал каждый раз, когда кто-то новый с ним разговаривал.",
  "landing.founderLine2": "Учителя. Другие дети. Люди снаружи.",
  "landing.founderLine3": "Дома он мог говорить нормально. Стоило ему оказаться где-то еще, и все пропадало.",
  "landing.founderLine4": "Я искал приложения для помощи. Все, что я нашел, было сложным и бесполезным.",
  "landing.founderLine5": "Затем я встретил родителя, чей ребенок буквально не мог сказать «Я голоден» или поддерживать общение с близкими.",
  "landing.founderLine6": "Две разные проблемы. Ноль хороших решений. Поэтому я начал создавать Time To Talk в 16 лет: нажмите на значок, и приложение заговорит, практикуйте разговоры без давления и получайте помощь в реальном времени, когда вы замрете. Для всех, кому нужна помощь в разговорах.",
  "landing.founderAttribution": "Гинтарас, основатель Time To Talk",
  "landing.finalCtaTitle": "Им есть что сказать.",
  "landing.finalCtaSubtitle": "Давайте поможем им сказать это.",
  "landing.finalCtaButton": "Получить Time To Talk",
  "landing.faqDropdownTitle": "FAQ",
  "landing.pricingDropdownTitle": "Цены",
  "landing.priceIncreaseBanner": "Стартовая цена заканчивается через {timeLeft}",
  "landing.pricingTitle": "Цены.",
  "landing.ctaSeePlans": "Выбрать план",
  "landing.stickyCta": "Получить Time To Talk",
  "landing.howTitle": "Начните помогать сегодня",
  "landing.priceTeaserCta": "Посмотреть все цены",
};
